import {Select} from 'antd'
import {Option} from 'antd/es/mentions'
import {CreativeBean} from 'common/api/api'
import React from 'react'
import {DictionarySelectorProps} from './DictionarySelector'
import MraidEnum = CreativeBean.MraidEnum

export const MraidVersionSelector: React.FC<DictionarySelectorProps> = (props) =>
    <Select {...props} allowClear mode="multiple">
        <Option key={String(MraidEnum.MRAID2)} value={String(MraidEnum.MRAID2)}>MRAID 2.0</Option>
        <Option key={String(MraidEnum.MRAID3)} value={String(MraidEnum.MRAID3)}>MRAID 3.0</Option>
    </Select>
